import { ITab } from 'helpers/tabs';

let subMenu : ITab[] = [ 
    { title: 'Storia', url: '/company/history' },
    { title: 'Mission & Vision', url: '/company/mission' },
    { title: 'Il nostro metodo', url: '/company/method' }
];

export default subMenu ;